import { render, staticRenderFns } from "./ImgTurnPage.vue?vue&type=template&id=bfa7c60c&scoped=true&"
import script from "./ImgTurnPage.vue?vue&type=script&lang=js&"
export * from "./ImgTurnPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa7c60c",
  null
  
)

export default component.exports